import * as React from 'react';

type ConnectionDetectorPropsType = {
	doSetOnline: () => void;
	doSetOffline: () => void;
};

type ConnectionDetectorStateType = {
	online: boolean;
};

const EVENTS = {
	ONLINE: 'online',
	OFFLINE: 'offline',
};

class ConnectionDetector extends React.Component<ConnectionDetectorPropsType, ConnectionDetectorStateType> {
	public static displayName = 'ConnectionDetector';

	constructor(props: ConnectionDetectorPropsType) {
		super(props);

		this.state = {
			online: typeof navigator.onLine === 'boolean' ? navigator.onLine : true,
		};
	}

	public componentDidMount() {
		window.addEventListener(EVENTS.ONLINE, this.onOnlineListener.bind(this));
		window.addEventListener(EVENTS.OFFLINE, this.onOfflineListener.bind(this));
	}

	public componentWillUnmount() {
		window.removeEventListener(EVENTS.ONLINE, this.onOnlineListener.bind(this));
		window.removeEventListener(EVENTS.OFFLINE, this.onOfflineListener.bind(this));
	}

	public onOnlineListener() {
		this.setState(
			{
				online: true,
			},
			this.props.doSetOnline
		);
	}

	public onOfflineListener() {
		this.setState(
			{
				online: false,
			},
			this.props.doSetOffline
		);
	}

	public render() {
		return null;
	}
}

export default ConnectionDetector;
